<template>
    <div class="fixed z-50 top-0 left-0 w-full block">
        <router-link :to="{ name: 'MainMenu' }">
          <img
          :src="icon"
          class="w-16 sm:w-24 md:w-32 mx-auto md:mx-0 md:ml-4"
          />
        </router-link>

        <span class="absolute hidden md:block text-right top-0 right-0 mr-3" v-if="user.loggedIn">

         <span class="text-xs block"> you are logged in as </span>
         <span class="text-xs block">{{user.data.email}} <a class="cursor-pointer underline" @click="logout()">Sign Out</a></span>
         <router-link class="border-black inline-block border-2 px-4 py-2 mt-6" v-if="user.profile.isAdmin" :to="{ name: 'Admin' }">Insights</router-link>
        </span>
    </div>
</template>

<script>
import firebase from "firebase/app";
import { mapState } from "vuex";
export default {
    data() {
        return {
            icon: require("@/assets/img/SVG/BFG.svg")
        }
    },
    computed: {
      ...mapState({
        user: "user"
      })
    },
    methods: {
      logout() {
        firebase
          .auth()
          .signOut()
          .then(() => {
            this.$router.replace({
              name: "MainMenu"
            });
          });
      }
    }
}
</script>
